import React from 'react'
import { useIntl } from 'react-intl'

import { ShelfErrorState } from '../ShelfErrorState'
import type { GenericErrorProps } from '../../../../../../core/screens/GenericError'

export type ProductsShelfErrorStateProps = GenericErrorProps

export const ProductsShelfErrorState = (
  props: ProductsShelfErrorStateProps
) => {
  const { formatMessage } = useIntl()

  return (
    <ShelfErrorState
      workflowType="products-shelf-error-render"
      title={formatMessage({ id: 'collectionsShelfErrorStateTitle' })}
      description={formatMessage({
        id: 'produts-shelf-error-state-description',
      })}
      {...props}
    />
  )
}
